export default {
  LANG_CODE: 'es',
  LANG_NOT_FOUND: 'Actualmente no admitimos el idioma que está intentando seleccionar.',
  LANG_HAS_DELETED: 'Actualmente no admitimos el idioma seleccionado, póngase en contacto con nuestro equipo de asistencia.',
  USER_ID: 'ID de usuario',
  USER_NAME: 'Nombre de usuario',
  PASSWORD: 'Contraseña',
  REQUIRED_FIELD: 'es un campo obligatorio',
  FORGOT_PASSWORD: 'Contraseña olvidada',
  API_DEFAULT_ERROR: 'Algo ha ido mal, inténtelo de nuevo después de algún tiempo.',
  SUPPORT_LABEL: 'Si hay problemas con el nombre de usuario o contraseña, contacte a',
  BACK_TO_LOGIN: 'Volver al inicio de sesión',
  SUBMIT: 'Enviar',
  YES: 'Sí',
  NO: 'No',
  DELETE: 'Borrar',
  LOGOUT: 'Cerrar sesión',
  LOGOUT_POPUP_TITLE: '¿Desea cerrar la sesión?',
  EVENT_INFO: 'Información del evento',
  QUALIFYING_QUESTIONS: 'Preguntas calificadoras',
  CONTENT: 'Contenido',
  EMAILS: 'Correos',
  PREVIOUS: 'Anterior',
  CONTINUE: 'Continuar',
  FINISH: 'Finalizar',
  ADD: 'Añadir',
  CANCEL: 'Cancelar',
  APPROVE: 'Aprobar',
  INVALID_FIELD: 'el campo no es válido',
  SET: 'Configurar',
  EXHIBITORS: 'Expositores',
  EVENT_ID: 'Id de evento',
  PASS_MIN_LEN_ERROR: 'Debe contener al menos 6 caracteres.',
  SAVE: 'Guardar',
  EDIT: 'Editar',
  COOCKIE_POLICY: 'Política de cookies',
  COOCKIE_TEXT:
    'Las cookies nos ayudan a prestar nuestros servicios. Utilizamos cookies técnicas para ofrecerle la mejor experiencia en nuestro sitio web. Al cerrar esta ventana o continuar usando el sitio, usted acepta el uso que hacemos de dichas cookies. Más información en',
  COOCKIE_POLICY_LINK: 'https://fielddrive.com/cookie-policy/',
  SUCCESS_TITLE: '¡Éxito!',
  FAILED_TITLE: '¡Falló!',
  OR: 'o',
  EVENT_SETTINGS: 'Configuración de eventos',
  LEADS: 'Dirige',
  COPIED: 'Copied!',
  PREVIEW: 'Preview',
  RENAME: 'Rename',
  DELETE_LABEL: '¿Desea borrar este'
}
